import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ForgotUsernameCredentials } from '@pages/login-recovery-options/models/forgot-username-credentials.interface';
import { LoginRecoveryFacade } from '@pages/login-recovery-options/facades/login-recovery.facade';
import {
  fullEmailValidators,
  InputComponent,
  inputValidators,
  LargeButtonComponent,
  LinkComponent,
  PrefetchLinkDirective,
} from '@kaseya-design-components';
import { TranslatePipe } from '@ngx-translate/core';
import { Router, RouterLink } from '@angular/router';

import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { LoginRecoveryPath } from '@pages/login-recovery-options/routes/login-recovery-path.enum';

@Component({
  selector: 'itc-recover-username',
  templateUrl: 'recover-username.component.html',
  styleUrl: 'recover-username.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputComponent, LargeButtonComponent, LinkComponent, TranslatePipe, RouterLink, PrefetchLinkDirective],
})
export class RecoverUsernameComponent {
  private readonly router = inject(Router);
  private readonly loginRecoveryFacade = inject(LoginRecoveryFacade);

  readonly loading = this.loginRecoveryFacade.loading;

  readonly recoveryForm = new FormGroup({
    userEmail: new FormControl('', { nonNullable: true, validators: fullEmailValidators }),
    organizationName: new FormControl('', {
      nonNullable: true,
      validators: [inputValidators.required, inputValidators.notEmptyOrWhiteSpaces],
    }),
  });
  readonly ApplicationPath = ApplicationPath;
  readonly LoginRecoveryPath = LoginRecoveryPath;

  recoverCredentials(): void {
    this.loginRecoveryFacade.recoverCredentialsByUsername(this.recoveryForm.value as ForgotUsernameCredentials);
  }

  backToLogin(): void {
    this.router.navigateByUrl(ApplicationPath.Login);
  }
}
